import React from 'react';
import AriaLiveRegion from '../AriaLiveRegion';
import { getValidatorForFieldType, validationMessages } from '../../utils/validators';

function TextInput({ index, inputField, handleInputChange, handleMouseEnter, handleMouseLeave, hoveredIndex, windowWidth, pageHeight, pageWidth }) {
  const hasError = !inputField.valid;
  const isSuccess = inputField.valid && inputField.value && inputField.value.trim() !== '';
  const errorId = hasError ? `error-${inputField.editor.inputType.value}-${index}` : undefined;
  const fieldLabel = inputField.editor.inputType.label || inputField.editor.inputType.value;

  // Get validation error message if exists
  const validator = getValidatorForFieldType(inputField.editor.inputType.value);
  let validationError = '';
  if (hasError && inputField.value && validator) {
    validationError = validator(inputField.value) || `שדה ${fieldLabel} דורש תיקון`;
  } else if (hasError) {
    validationError = `שדה ${fieldLabel} דורש תיקון`;
  }

  // CRITICAL FIX: Calculate rendered PDF height correctly
  // The PDF is rendered with width={windowWidth}, so height is scaled proportionally
  // Safety check: Don't render if dimensions aren't available yet
  if (!pageWidth || !pageHeight || !windowWidth) {
    console.warn('[TextInput] Missing dimensions:', { pageWidth, pageHeight, windowWidth });
    return null;
  }

  const renderedHeight = windowWidth * (pageHeight / pageWidth);
  const fieldHeight = windowWidth * inputField.editor.height / 40;

  return (
    <>
      <input
        key={index}
        type="text"
        value={inputField.value}
        onChange={(event) => handleInputChange(event, index)}
        aria-label={fieldLabel}
        aria-invalid={hasError}
        aria-describedby={errorId}
        aria-required={inputField.mandatory ? 'true' : 'false'}
        style={{
          opacity: `${hoveredIndex === index || inputField.editor.state ? 0.8 : 1}`,
          position: 'absolute',
          top: inputField.y * renderedHeight,
          left: inputField.x * windowWidth,
          width: `${(windowWidth * inputField.editor.width / 1.5)}px`,
          height: `${fieldHeight}px`,
          fontSize: `${windowWidth / 60}px`,
          padding: '4px',
          border: hasError ? '2px solid #ef4444' : isSuccess ? '2px solid #22c55e' : '1px solid #e5e7eb',
          borderRadius: '4px',
          transition: 'all 0.2s ease',
          boxShadow: hasError ? '0 0 0 3px rgba(239, 68, 68, 0.1)' : isSuccess ? '0 0 0 3px rgba(34, 197, 94, 0.1)' : 'none',
        }}
        onMouseEnter={(event) => handleMouseEnter(event, index)}
        onMouseLeave={handleMouseLeave}
      />
      {/* Validation feedback */}
      {hasError && validationError && (
        <div
          id={errorId}
          style={{
            position: 'absolute',
            top: inputField.y * renderedHeight + 4,
            left: inputField.x * windowWidth,
            fontSize: `${Math.max(windowWidth / 100, 11)}px`,
            color: '#ef4444',
            fontWeight: '500',
            pointerEvents: 'none',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '2px 6px',
            borderRadius: '4px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            maxWidth: `${(windowWidth * inputField.editor.width / 1.5)}px`,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          ⚠️ {validationError}
        </div>
      )}
      {isSuccess && (
        <div
          style={{
            position: 'absolute',
            top: inputField.y * renderedHeight,
            left: inputField.x * windowWidth + (windowWidth * inputField.editor.width / 1.5) + 4,
            fontSize: `${windowWidth / 60}px`,
            color: '#22c55e',
            fontWeight: 'bold',
            pointerEvents: 'none',
          }}
        >
          ✓
        </div>
      )}
      {/* Hidden error for screen readers */}
      {hasError && (
        <AriaLiveRegion
          message={validationError}
          type="error"
          visible={false}
        />
      )}
    </>
  );
}

export default TextInput;
